exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".optionsForm {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column; }\n  .optionsForm__edge-label-ctrl {\n    margin-top: 1.2rem;\n    margin-bottom: 1rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /builds/cp/frap/t3/planer/src/app/nav/compv/nav-graph-view-options/nav-graph-view-options.scss
// module id = ../../../../../src/app/nav/compv/nav-graph-view-options/nav-graph-view-options.scss
// module chunks = main